module.exports = __webpack_public_path__ + "assets/img/12_44.0c18e6ed.jpg";